/**
 * Public client configuration.
 *
 * All three are `NEXT_PUBLIC_` and end up in the browser bundle, which is by
 * design: the Supabase anon key is a public client key and the custom IAM in
 * packages/database is what protects the data. Nothing secret belongs here.
 *
 * The prefix outlived Next deliberately — `envPrefix` in `vite.config.ts` keeps
 * it, because these names are also the contract with the SSM parameters that
 * `sst.config.ts` reads at deploy time. See the note there.
 *
 * Read through accessors rather than exported constants so a missing variable
 * fails at the first use with a message naming it, instead of silently becoming
 * `undefined` and surfacing later as a fetch to `undefined/graphql`.
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `${name} is not set. Copy packages/app/.env.example to .env.local and fill it in.`,
    );
  }

  return value;
}

/** The Lambda API Gateway origin — `/graphql` and every REST route hang off it. */
export function apiUrl(): string {
  return required(
    'NEXT_PUBLIC_API_URL',
    import.meta.env.NEXT_PUBLIC_API_URL,
  ).replace(/\/$/, '');
}

/** The Supabase project origin. Auth only — data goes through the API. */
export function supabaseUrl(): string {
  return required(
    'NEXT_PUBLIC_SUPABASE_URL',
    import.meta.env.NEXT_PUBLIC_SUPABASE_URL,
  );
}

export function supabaseAnonKey(): string {
  return required(
    'NEXT_PUBLIC_SUPABASE_ANON_KEY',
    import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
  );
}
